const FlowZIndex = {
  EDGES: 1,
  REGULAR_NODE: 2,
  /** Group nodes, their children and edges are stacked above regular nodes and stacked
   * against each other using dynamic z-index values.
   * Groups start at 1 and increment by 3 for each subsequent group.
   * We support up to 166 groups (3 * 166 = 498)
   */
  NODE_HANDLE: 500, // Must be above max node z-index (96 for group children)
};

const PanelsZIndex = {
  /** Standard panels (Property drawer, Left menu, etc.) use ReactFlow Panel components and don't need explicit z-index values */
  /** Recipe overlay panels that cover the ReactFlow canvas (e.g., Media Gallery, Design App, Editor, Dialog overlays) */
  RECIPE_OVERLAY_PANELS: 550,
};

const OverlaysZIndex = {
  LOADING_OVERLAY: 1000,
  STICKY_TOP_BANNER: 1100,
  PRODUCT_TOUR_OVERLAY: 1200,
  CONTEXT_MENUS_POPOVERS: 1300,
  CONFIRMATION_DIALOGS: 1400, // Above all context inside app
  /** Font menus, selects, and other anchored panels opened from within dialogs (must stack above CONFIRMATION_DIALOGS). */
  ANCHORED_POPPER_ABOVE_DIALOG: 1450,
  /** Global snackbar toasts (must stack above modals and dialog-anchored poppers). */
  APP_SNACKBAR: 1500,
  CRITICAL_SYSTEM_ALERT: 9999, // Above all else
};

export const ZIndex = {
  // Flow components have a separate z-index context and are always below panels and modals.
  // Modals should have a higher z-index range so that they are above all.
  Flow: FlowZIndex,
  Panels: PanelsZIndex,
  Overlays: OverlaysZIndex,
};
